<p>{{ 'global-settings.accounting-packages.edit.quick-books.authentication-landing-message' | translate }}</p>
